import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { AddDealershipComponent }             from './company.add-dealership.component';
import { AnnualSubscriptionComponent }        from './company.annual-subscription.component';
import { BuySmsComponent }                    from './company.buy-sms.component';
import { CancelSubscriptionComponent }        from './company.cancel-subscription.component';
import { CompanyIntegrationPipe }             from './company.integration.pipe';
import { CompanyService }                     from './company.service';
import { CompanySetUpComponent }              from './company.set-up.component';
import { CompanyTypeComponent }               from './company.company-type.component';
import { ShareAccoutingComponent }            from './company.share-accounting.component';
import { SharedModule }                       from '../shared/shared.module';
import { UpdateSubscriptionPaymentComponent } from './company.update-subscription-payment.component';

@NgModule({
    declarations: [
      AddDealershipComponent,
      AnnualSubscriptionComponent,
      BuySmsComponent,
      CancelSubscriptionComponent,
      CompanyIntegrationPipe,
      CompanyTypeComponent,
      CompanySetUpComponent,
      ShareAccoutingComponent,
      UpdateSubscriptionPaymentComponent
    ],
    entryComponents: [
      AddDealershipComponent,
      AnnualSubscriptionComponent,
      BuySmsComponent,
      CancelSubscriptionComponent,
      CompanyTypeComponent,
      CompanySetUpComponent,
      ShareAccoutingComponent,
      UpdateSubscriptionPaymentComponent
    ],
    exports: [
      CompanyIntegrationPipe,
      CompanyTypeComponent,
    ],
    imports: [
      SharedModule
    ],
    providers: [
      CompanyIntegrationPipe,
      CompanyService,

      {
        provide : 'companyIntegration',
        useClass: CompanyIntegrationPipe
      }
    ],
    schemas: [NO_ERRORS_SCHEMA],
  })
  export class CompaniesModule {}